var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.result)?_c('find-account-form',{attrs:{"type":"password"},on:{"verified":_vm.verified}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }